jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     $('[data-variant-toggle]').hide(0);
	     $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
         // Code added by Talib Allauddin 18/4/2024
         setTimeout(calcuatePrice, 500);

         var clones = jQuery(".t4s-product__price-review .exemptify_clone");

          // Check if there is more than one .exemptify_clone element
          if (clones.length > 1) {
              // Loop through each .exemptify_clone element
              clones.each(function() {
                  // Check if the element's display is 'none'
                  if (jQuery(this).css("display") === "none") {
                      // Remove the element
                      jQuery(this).remove();
                  }
              });
          }
       });
  calcuatePrice();
});

function calcuatePrice() {
  var el = document.querySelector("#ProductInfo-template--template--21037371064663__main__main > div.t4s-product__price-review > div.exemptify_clone");
  if (el) {
    var amount = el.innerHTML;
    el.innerHTML = amount
    amount = amount.replace(/[^0-9,\.]/g, '').replace('.','').replace(',', '.');
    console.log("amount 1");
    amount = parseFloat((amount/1.21));
    amount = parseFloat(amount).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    document.querySelector("#ProductInfo-template--template--21037371064663__main__main > div.t4s-product__price-review > small").innerHTML = amount + ' (excl. BTW)';
  } else {
    var el = document.querySelector("#ProductInfo-template--template--21037371064663__main__main > div.t4s-product__price-review > div.t4s-product-price > ins");
    var amount = el.innerHTML;
    amount = amount.replace(/[^0-9,\.]/g, '').replace('.','').replace(',', '.');
    console.log("amount 2");
    amount = parseFloat((amount/1.21));
    amount = parseFloat(amount).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    document.querySelector("#ProductInfo-template--template--21037371064663__main__main > div.t4s-product__price-review > small").innerHTML = amount + ' (excl. BTW)';
  }
  
}

jQuery(document).ready(function($){
  // $("#MainContent").prepend('<a href="//www.keurmerk.info/nl/consumenten/webwinkel/?key=15050" class="review-mark" target ="_blank"><img alt="Onze vermelding op sys.keurmerk.info/" src="//sys.keurmerk.info/Resources/Logo/logo_d_medium.png?l=nl" border="0" /></a>')
  $("#MainContent").prepend('<iframe class="review-mark" title="Webshop Keurmerk lidmaatschap en review score" src="https://review-data.keurmerk.info/rcore/review.html?key=15050&lang=nl&mode=compact" style="border:0" width="80" height="93"></iframe>')
  $("#enquiry_btn").click(function(){
    $("#enquiry-form").css("display", "block");
  });
  $("ul.single-prod-tabs li").click(function(){
      $(this).addClass("active").siblings().removeClass("active")
  })
  $("ul.single-prod-tabs li.desc").click(function(){
      $(".t4s-product__description").show()
      $(".specification").hide()
  })
  $("ul.single-prod-tabs li.spec").click(function(){
      $(".specification").show()
      $(".t4s-product__description").hide()
  })
})


//Set Minimum Quantity Start

document.querySelectorAll('.t4s-quantity-input').forEach(input => {
  input.addEventListener('change', function() {
    const itemKey = this.dataset.id;
    const minQty = this.getAttribute('min');
    let qty = parseInt(this.value);
    
    if (qty < minQty) {
      qty = minQty;
      this.value = minQty;
    }
    
    const unitPrice = parseFloat(this.closest('.t4s-quantity-wrapper').dataset.unitPrice);
    const newTotal = unitPrice * qty;
    
    document.querySelector(`.t4s-cart-item-price[data-id="${itemKey}"]`).textContent = Shopify.formatMoney(newTotal * 100, "{{ shop.money_format }}");
    
    // Update the subtotal and total prices here (e.g., by recalculating and updating the DOM)
  });
});

//Set Minimum Quantity End